export default "/wp-content/themes/onnit/script/cart/dist/successBG-20af8ccf.png";